import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { debounce } from '../../shared/elements/debounce';
import { ThemeEditorSectionConfigService } from './sections.service';

@Component({
    selector: 'mvta-theme-editor-quote',
    templateUrl: 'quote.component.html'
})
export class ThemeEditorQuoteConfigComponent implements OnInit {
    ckEditorConfig = {
        autoParagraph: false, // Do not enclosing p
        removeButtons: 'Source,Save,Templates,Cut,Undo,Find,SelectAll,Scayt,Form,CopyFormatting,RemoveFormat,NumberedList,Outdent,' +
        'Blockquote,BidiLtr,Image,Styles,TextColor,Maximize,About,ShowBlocks,BGColor,Format,Font,FontSize,NewPage,' +
        'Preview,Print,PasteText,Paste,Copy,Replace,Redo,PasteFromWord,Checkbox,Radio,TextField,Textarea,Select,Button,' +
        'ImageButton,HiddenField,BulletedList,Indent,CreateDiv,BidiRtl,Anchor,' +
        'Language,Flash,Table,HorizontalRule,SpecialChar,Smiley,PageBreak,Iframe,Subscript,Superscript,Strike'
    };
    sectionValue;
    debouncedSectionChange;

    @Input()
    get section() {
        return this.sectionValue;
    }

    set section(val) {
        if (val === null || val === undefined || val.isNew) {
            this.sectionValue = this.defaultValues();
            this.sectionValue.isTop = val.isTop || false;
            return;
        }
        this.sectionValue = val;
    }

    @Output()
    goBack = new EventEmitter();

    @Output()
    sectionChange = new EventEmitter();

    @Output()
    sectionDelete = new EventEmitter();

    constructor(private sectionService: ThemeEditorSectionConfigService) {
    }

    ngOnInit() {
        this.debouncedSectionChange = debounce(() => {
            this.sectionChange.emit(this.sectionValue);
        }, 800);
        if (this.sectionValue.isNew) {
            this.sectionChange.emit(this.sectionValue);
        }
    }

    onSectionChange() {
        this.debouncedSectionChange();
    }

    onDeleteSection() {
        this.sectionDelete.emit(this.sectionValue);
    }

    onGoBack(ev) {
        this.goBack.emit(ev);
    }

    defaultValues() {
        return {
            type: 'quote',
            isNew: true,
            id: this.sectionService.getRandomId(),
            settings: {
                quote: 'Contenido de tu <strong>cita</strong>',
                author: 'Autor',
            },
        };
    }
}
